import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/companies";
import { fetchData, getCompaniesFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";
import { useSupabaseApp } from "../../../SupabaseApp";

import "../datatable-pages.css";

/**
 * ProductsShowcase Component
 * 
 * Displays a paginated datatable of active products with detailed product and company information.
 * Users can browse and search through 25+ product and company attributes.
 * Shows statistics on active products and status unknown products.
 * Requires user authentication to access.
 * 
 * @returns {JSX.Element} Datatable page with products showcase data
 */
const ProductsShowcase = () => {
  // Array of field keys to display in the products datatable
  const fieldKeys = [
    "tradeName",
    "stageOfDevelopment",
    "industry",
    "description",
    "categories",
    "location",
    "ownership",
    "businessModelType",
    "defensibilityMoat",
    "productReview",
    "lastFinancingRound",
    "totalInvestment",
    "postMoneyValuation",
    "lastFinancingDate",
    "numOfFundingRounds",
    "numOfInvestors",
    "investors",
    "competitors",
    "similarEntities",
    "management",
    "numOfEmployees",
    "phoneNumber",
    "operationalDuration",
    "foundedDate",
    "pitchdeck_show",
  ];
  // Convert field keys to formatted field objects
  const fields = getCompaniesFieldsArray(fieldKeys);

  // Get datatable state and props
  const { datatableProps } = useDatatable();

  // Get Supabase utilities and user context
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // Check user authentication
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // Configuration for products datatable
  const params = {
    supabase,
    ...datatableProps,
    getData: "getProductsShowcase",
    collection: "companies",
    title: "Products showcase",
    datatipText:
      "Inspire to create value-added offering by browsing through our collection of active products.",
    statsArray: [
      {
        actualName: "activeProducts",
        displayName: "Active products",
        total: "968",
      },
      {
        actualName: "statusUnknown",
        displayName: "Status unknown",
        total: "24,140",
      },
    ],
    placeholderText: "Search from products showcase",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // Fetch products data on component mount
  useEffect(() => {
    fetchData(params);
  }, []);

  // Render datatable page with configured params
  return <DatatablePage props={props(params)} />;
};

export default ProductsShowcase;
